import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';

// view

import Loading from 'components/Loading';
import {
  HrTimestampList,
  HrTimestampApproval,
  HrCheckinManagement,
  EditTimestamp,
  OtRequest,
  FieldAllowanceRequest,
  HrEditEmployee,
  HrEmployee,
  HrReport,
  HrReportV2,
  HrReportDaily,
  HrPayrollAdmin,
  HrDashboard,
  HrAddEmployee,
  HrSalaryList,
  HrMonthlySalarySummary,
  HrAddSalary,
  HrSalaryDetail,
  HrEmployeeDetail,
  AddOt,
  EditOt,
  HrActivityLog,
  HrLeaveRequestList,
  HrAnnouncements,
} from '../views/Humen';
//

import { HomeNavbar } from '../components/Nevbars';
import { MainFooter } from '../components/Footers';
import { MainSidebar } from '../components/Sidebar';
import { NotFound, AccessDenied } from '../components/Error';
import { hasModuleAccess } from '../utils/functions/accessRight';
import * as actions from '../redux/actions';

export function Humen() {
  const module = 'HUMEN';
  const prefix = '/humen';
  const name = 'humen';
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const me = useSelector((state) => state.me);

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };
  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };
  useEffect(() => {
    dispatch(actions.meGet());

    return () => {};
  }, []);
  if (!me.userData) {
    return <Loading />;
  }
  if (!hasModuleAccess(me, module)) {
    return <AccessDenied moduleLabel="ทรัพยากรบุคคล" />;
  }
  return (
    <div className="min-h-screen" style={{ overflowX: 'hidden' }}>
      <MainSidebar
        onMobileClose={handleOnMobileNavClose}
        openMobile={isMobileNavOpen}
        me={me}
      />
      <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />

      <div className={`relative ${'lg:ml-20'} transition-all duration-200 min-h-screen pt-2 px-8`} style={{ overflowX: 'hidden' }}>
        <div className="py-4">
          <Switch>
            {' '}
            <Route exact path={`${prefix}/report`}>
              <HrReport title="รายงานรายเดือน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/hr-report-v2`}>
              <HrReportV2 title="สรุปเงินเดือน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/payroll-admin`}>
              <HrPayrollAdmin title="สรุปเงินเดือน (Admin)" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/reportDaily`}>
              <HrReportDaily title="บันทึกเวลารายวัน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/checkin-management`}>
              <HrCheckinManagement title="จัดการการลงเวลา" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/timestamp`}>
              <HrTimestampList title="รายการบันทึกเวลา" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/timestamp-approval`}>
              <HrTimestampApproval title="คำขอลงเวลานอกพื้นที่" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/timestamp-dashboard`}>
              <HrDashboard title="แดชบอร์ด" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/timestamp/edit/:id`}>
              <EditTimestamp title="แก้ไข" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/ot-request`}>
              <OtRequest title="คำขอโอที" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/ot-request/add`}>
              <AddOt title="เพิ่มโอที" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/ot-request/edit/:id`}>
              <EditOt title="แก้ไขโอที" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/employee`}>
              <HrEmployee title="พนักงาน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/employee/detail/:id`}>
              <HrEmployeeDetail title="รายละเอียดพนักงาน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/salarylist`}>
              <HrSalaryList title="เงินเดือน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/monthly-salary-summary`}>
              <HrMonthlySalarySummary title="สรุปเงินเดือนรวมทั้งเดือน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/salarylist/detail/:id`}>
              <HrSalaryDetail title="รายละเอียดเงินเดือน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/salarylist/add`}>
              <HrAddSalary title="เพิ่มเงินเดือน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/employee/add`}>
              <HrAddEmployee title="เพิ่มพนักงาน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/employee/edit/:id`}>
              <HrEditEmployee title="แก้ไข" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/activity-log`}>
              <HrActivityLog title="บันทึกกิจกรรม (HR)" />
            </Route>
            <Route exact path={`${prefix}/leave-request`}>
              <HrLeaveRequestList title="คำขอลา" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/announcements`}>
              <HrAnnouncements title="ประกาศ" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/field-allowance-request`}>
              <FieldAllowanceRequest title="คำขอค่าออกสนาม" subtitle={name} />
            </Route>
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </div>
      </div>
      <div className={`${'lg:ml-20'} transition-all duration-200`}>
        <MainFooter />
      </div>
    </div>
  );
}

export default Humen;
